// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login[data-v-38b164d8]{height:100vh;height:calc(var(--vh, 1vh)*100)}.login__content[data-v-38b164d8]{margin-top:8rem;grid-gap:1rem;gap:1rem}.login__btn[data-v-38b164d8]{border-radius:16px!important}.login__btn[data-v-38b164d8] .v-btn__content{line-height:1.55}.login__form[data-v-38b164d8]{grid-gap:1rem;gap:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
